// Single source of truth for the blog index and per-post metadata.
// Adding a new article = add an entry here + add the matching route in App.js
// pointing to the corresponding page component.
export const BLOG_POSTS = [
  {
    slug: "sante-pologne-scandale-szpital-poludniowy",
    title: "Salaires de médecins et salon VIP : le scandale du Szpital Południowy",
    excerpt:
      "Rémunérations hors normes, salon VIP réservé à des responsables politiques, files d'attente à deux vitesses : ce que l'affaire du Szpital Południowy révèle du système de santé polonais, et ce qu'un futur expatrié doit en retenir.",
    datePublished: "2026-07-08",
    dateModified: "2026-07-08",
    dateLabel: "8 juillet 2026",
    image: "/images/blog/sante-pologne-scandale-szpital-poludniowy.png",
  },
  {
    slug: "pacte-migratoire-pologne",
    title: "Pacte migratoire de l'UE : pourquoi la Pologne refuse la relocalisation",
    excerpt:
      "Le pacte migratoire européen s'applique depuis le 12 juin 2026. La Pologne refuse la relocalisation et obtient une exemption, sur fond de tensions à la frontière biélorusse.",
    datePublished: "2026-06-26",
    dateModified: "2026-06-26",
    dateLabel: "Mis à jour en juin 2026",
    image: "/images/blog/pacte-migratoire-pologne.png",
  },
  {
    slug: "travailler-pologne-reforme-2025",
    title: "Travailler en Pologne après la réforme de 2025",
    excerpt:
      "Depuis le 1er juin 2025, la Pologne a réformé l'emploi des étrangers. Ce qui change pour les ressortissants de pays tiers, pourquoi et les premières conséquences.",
    datePublished: "2026-06-15",
    dateModified: "2026-06-15",
    dateLabel: "Mis à jour en juin 2026",
    image: "/images/blog/reforme-travail-pologne-2025.png",
  },
];
